<template>
  <!-- eslint-disable max-len -->
  <div id="main">
    <div class="container">
      <h2>
        {{ $translation.L('KMMF_SEMMINARS') }}
      </h2>
      <ul class="responsive-table">
        <li class="table-header">
          <div class="col col-1">{{ $translation.L('SEMMINARS_NAME') }}</div>
          <div class="col col-2">{{ $translation.L('SEMMINARS_DATE') }}</div>
          <div class="col col-3">{{ $translation.L('SEMMINARS_PLACE') }}</div>
          <div class="col col-3">{{ $translation.L('SEMMINARS_LINK') }}</div>
        </li>
        <li v-for="item in jsonData" :key="item.name" class="table-row">
          <div class="col col-1" :data-label="$translation.L('SEMMINARS_NAME')">{{$translation.L(item.name)}}</div>
          <div class="col col-2" :data-label="$translation.L('SEMMINARS_DATE')">{{$translation.L(item.date)}}</div>
          <div class="col col-3" :data-label="$translation.L('SEMMINARS_PLACE')">{{$translation.L(item.location)}}</div>
          <div v-if="item.link != 'none'" class="col col-4" :data-label="$translation.L('SEMMINARS_LINK')"><a target="_blank" :href="item.link">{{ $translation.L('ENTER_WEBSITE') }}</a></div>
          <div v-if="item.link === 'none'" class="col col-4" :data-label="$translation.L('SEMMINARS_LINK')">{{ $translation.L('NO_WEBSITE') }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'semminary',
  data() {
    return {
      jsonData: this.$config.semminars,
    };
  },

};

</script>

<style scoped>
#main {
  display: block;
  width: 100%;
  height: 80%;
  background-color: white;
  padding: 5px 0;
}

a {
    cursor: pointer;
    text-decoration: underline;
    color: #333;
    height: 150%;
    transition: color 0.2s ease-in-out;
}

a:hover {
    color: #111;
}

.container {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 10px;
  padding-right: 10px;
}

h2 {
  font-size: 26px;
  margin: 20px 0;
  text-align: center;
  color: #333;
}
h2 small {
  font-size: 0.5em;
}

.responsive-table li {
  border-radius: 3px;
  padding: 25px 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.responsive-table .table-header {
  background-color: #4d5499;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.responsive-table .table-row {
  background: #c9ceff;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
  color: black;
  font-size: 16px;
}
.responsive-table .col-1 {
  flex-basis: 40%;
}
.responsive-table .col-2 {
  flex-basis: 25%;
}
.responsive-table .col-3 {
  flex-basis: 10%;
}
.responsive-table .col-4 {
  flex-basis: 10%;
}
@media all and (max-width: 1023px) {
  .container {
    max-width: 100%;
  }
  .responsive-table .table-header {
    display: none;
  }
  .responsive-table li {
    display: block;
  }
  .responsive-table .col {
    flex-basis: 100%;
  }
  .responsive-table .col {
    display: flex;
    padding: 10px 0;
    text-align: center;
    flex-direction: row;
    font-size: 3.5vw;
  }
  .responsive-table .col:before {
    color: #4d5499;
    padding-right: 10px;
    content: attr(data-label);
    flex-basis: 50%;
    text-align: left;
    margin-right: 20%;
  }
}
</style>
